function RepeatSvg() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.933 13.0409C19.7442 14.4809 19.1669 15.8423 18.2632 16.9791C17.3594 18.1159 16.1633 18.9853 14.803 19.4939C13.4427 20.0026 11.9696 20.1314 10.5417 19.8665C9.11374 19.6016 7.78486 18.953 6.69755 17.9902C5.61024 17.0275 4.80551 15.7869 4.36967 14.4016C3.93383 13.0162 3.88332 11.5384 4.22355 10.1265C4.56379 8.71464 5.28194 7.42202 6.30097 6.38728C7.32001 5.35254 8.6015 4.61471 10.008 4.25292C13.907 3.25292 17.943 5.25992 19.433 8.99992" stroke="#252525"  />
<path d="M20 4V9H15" stroke="#252525"   />
</svg>

  )
};

export default RepeatSvg;